import {BodyM, LinkLDemibold, SubheaderL} from "../../styled-components/Font";
import {Logo} from "../../icons/Icons";
import {ContactText} from "./text";
import {BankDetails, BankDetailsText, Separator} from "../../styled-components/Base";
import {ContactContent, ContactLeftBlock, ContactRightBlock, Contacts, ContactsBlock, ContactSection} from "./Styled";
import {PopupProps} from "../../App";
import {useEffect, useRef, useState} from "react";
import useOnScreen from "../../hooks/useOnScreen";


export default function ContactInfo({onPopupOpen}: PopupProps) {
    const ref = useRef(null)
    const visible = useOnScreen(ref)
    const [isVisible, setIsVisible] = useState(false)
    useEffect(() => {
        if (visible) setIsVisible(true)
    }, [visible])

    return <>
        <ContactSection ref={ref}>
            <Separator className={isVisible ? 'animation4' : ''}/>
            <ContactContent className={isVisible ? 'animation2' : ''}>
                <ContactLeftBlock>
                    <Logo/>
                    <BankDetails>
                        <BankDetailsText>
                            Общество с ограниченной ответственностью «ДЕКА» <br/>
                            ИНН: 1659146518 <br/>
                            ОГРН: 1141690042757 <br/> <br/>
                            ОКВЭД: 62.01 Разработка компьютерного программного обеспечения <br/>
                            Вид деятельности в области информационных технологий: 1.01, 1.06, 2.01, 4.01
                        </BankDetailsText>
                    </BankDetails>
                </ContactLeftBlock>
                <ContactRightBlock>
                    <Contacts>
                        <ContactsBlock>
                            <SubheaderL>{ContactText.addressTitle}</SubheaderL>
                            <BodyM>{ContactText.address}</BodyM>
                        </ContactsBlock>
                        <SubheaderL>{ContactText.contact}</SubheaderL>
                        <BodyM onClick={() => window.open('tel:' + ContactText.phone)}>
                            {ContactText.phone}
                        </BodyM>
                        <BodyM>
                            {ContactText.email}
                        </BodyM>
                    </Contacts>
                    <LinkLDemibold onClick={() => onPopupOpen()}>
                        Запросить презентацию
                    </LinkLDemibold>
                </ContactRightBlock>
            </ContactContent>
        </ContactSection>
        <Separator className={isVisible ? 'animation4' : ''}/>
    </>
}
